const NbsMappingKeys = {
  TITLE: "title",
  PARTY_ID: "partyId",
  CHARGE_CODE: "chargeCode",
  TYPE: "type",
  ACCOUNT: "account"
}

export default NbsMappingKeys
